var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 1.875C0.04125 3.70875 0 4.99969 0 60C0 115 0.04125 116.291 1.875 118.125C3.61125 119.861 4.99969 120 20.625 120H37.5V94.725V69.4509L30.0778 69.1781L22.6547 68.9062L40.7981 48.75C50.7778 37.6641 59.4272 28.5938 60.0187 28.5938C60.6112 28.5938 69.2531 37.6641 79.2234 48.75L97.35 68.9062L89.925 69.1781L82.5 69.4509V94.725V120H99.375C115 120 116.389 119.861 118.125 118.125C119.959 116.291 120 115 120 60C120 4.99969 119.959 3.70875 118.125 1.875C116.291 0.04125 115 0 60 0C4.99969 0 3.70875 0.04125 1.875 1.875Z",
    fill: "#11A2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutIcon);
export default __webpack_public_path__ + "static/media/futIcon.fcbbff86aa1de28e2502d5122eaef107.svg";
export { ForwardRef as ReactComponent };